/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter, Link } from 'react-router-dom';
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import NumberFormat from "react-number-format";
// import Email from "react-email-autocomplete";

class JoinStepTree extends Component {
  _goShop = () => {
    window.open('https://shop.aniplustv.com', '', '');
  };
  _goFree = () => {
    const { history } = this.props;
    history.push('/ticket');
  };
  render() {
    const { username, userid, mobile, nicName, email } = this.props.childProps;

    return (
      <Fragment>
        <div className="login_content width7">
          <div className="login_padding">
            <h1>
              애니플러스
              <br />
              회원이 되신것을 환영합니다!
            </h1>
            <div className="join_end">
              <dl>
                <dt>회원정보</dt>
                <dd>
                  <span>이름</span>
                  {username}
                </dd>
                <dd>
                  <span>아이디</span>
                  {userid}
                </dd>
                <dd>
                  <span>닉네임</span>
                  {nicName}
                </dd>
                <dd>
                  <span>핸드폰</span>
                  {mobile}
                </dd>
                <dd>
                  <span>이메일</span>
                  {email}
                </dd>
              </dl>
            </div>
            <div style={{ height: 30 }}></div>
            {/* <div className="login_btn">
              <a style={{ cursor: "pointer" }} onClick={this._goFree}>
                30일 무료체험하기
              </a>
            </div> */}
            <div className="login_btn3">
              <Link to="/">메인으로</Link>
              <a style={{ cursor: 'pointer' }} onClick={this._goShop}>
                쇼핑하기
              </a>
            </div>
          </div>
        </div>

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(JoinStepTree));
